import { IHeaderOption } from 'props';
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as IconMaterialMoney } from '../../assets/icons/IconMaterialMoney.svg';
import { ReactComponent as IconWallet } from '../../assets/icons/IconWallet.svg';
import { ReactComponent as IconawesomeUserAlt } from '../../assets/icons/IconawesomeUserAlt.svg';
import { ReactComponent as BellNotificationManage } from '../../assets/icons/iconBellNotificationManage.svg';
import { ReactComponent as Crown } from '../../assets/icons/iconCrown.svg';
import { useAuth } from '../../context';
import { Accordion } from '../Accordion';
import { Container } from './styles';
import { ProfileType, TypeUser } from '../../types/enums';
import { InteractiveOptions } from '../InteractiveOptions';

export function OptionsProfile() {
  const [isOpen, setIsOpen] = React.useState(false);
  const { user } = useAuth();

  const options: (IHeaderOption & { icon: React.ReactNode })[] = useMemo(
    () => [
      {
        path: '/plan',
        enabled: false,
        name: 'Mude seu plano',
        icon: <Crown />,
      },
      {
        path: user.type === TypeUser.USER ? '/naturalPersonAccount' : '/legalPersonAccount',
        enabled: user.type !== TypeUser.COLLABORATOR,
        name: 'Meu perfil',
        icon: <IconawesomeUserAlt />,
      },
      {
        path: '/myvalues',
        enabled:
          user.type !== TypeUser.COLLABORATOR ||
          user.collaboratorInfo?.profileType === ProfileType.OPERATOR,
        name: 'Meus valores',
        icon: <IconMaterialMoney />,
      },
      {
        path: '/notification',
        name: 'Notificações',
        icon: <BellNotificationManage />,
      },
      {
        path: '/wallet',
        enabled: user.type !== TypeUser.COLLABORATOR,
        name: 'Carteira',
        icon: <IconWallet />,
      },
      {
        path: '/plans',
        enabled: user.type === TypeUser.ADM,
        name: 'Planos',
        icon: <IconMaterialMoney />,
      }
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [user.type],
  );

  return (
    <Container>
      <Accordion isOpen={isOpen} type="menu" title={<p>Olá, {user.firstName}</p>}>
        <div className="menuNavBar">
          {options
            .filter((o) => o.enabled !== false)
            .map((o) => (
              <Link key={o.path} className="optionMenuNavBar" to={o.path}>
                {o.icon}
                <p>{o.name}</p>
              </Link>
            ))}
          <InteractiveOptions handleIsOpenModal={(open) => setIsOpen(open)} />
        </div>
      </Accordion>
    </Container>
  );
}
